export default {
    title: '会社情報管理',
    pageTitle: '企業情報',
    editPageTitle: '企業情報を編集',
    basicInfo: '基本情報',
    personInCharge: '担当者情報',
    affiliatedEntity: '所属先',
    commonDocuments: '常用資料',
    registrationInfo: '登録支援機関',
    companyName: '会社名',
    legalEntity: '法人',
    legalEntityNumber: '法人番号（13桁）',
    companyType: '会社の種類',
    legalPersonId: '法人番号（13桁）',
    registrationDate: '設立日',
    establishmentDate: '会社の資本金（円）',
    employeeCount: '会社規模',
    foreignEmployeeCount: '外国人従業員数',
    businessScope: '営業利益(円/年)',
    website: '会社ホームページ',
    officeAddress: '会社住所',
    companyIntroduction: '会社紹介',
    registrationSupportService: '登録支援方式',
    trustMethod: '委託方法',
    remarks: '備考欄',
    contactName: '氏名',
    contactPosition: '役職',
    contactPhone: '電話番号／携帯番号',
    contactEmail: 'メールアドレス',
    mainIndustry: '主な業種',

    inputPlaceholder: '入力してください',
    selectPlaceholder: '選択してください',
    datePlaceholder: 'YYYY-MM-DD',

    paidIntroductionLicenseNumber: '有料職業紹介事業許可番号',
    paidIntroductionLicense: '有料職業紹介事業許可証',

    logo: {
        uploadText: '会社ロゴ',
        fileFormat: 'ファイル形式は jpg/jpeg/png/webp に限り、1ファイルあたりのサイズは10MB以下です。',
        uploadSuccess: 'Logo アップロード成功',
        uploadFailed: 'Logo アップロード失敗',
        changeButton: '変更',
        invalidFile: 'ファイルが無効です',
    },
    license: {
        uploadText: '許可証',
        fileFormat: 'ファイル形式は jpg/jpeg/png/webp/pdf に限り、1ファイルあたりのサイズは10MB以下です。',
        uploadSuccess: '許可証アップロード成功',
        uploadFailed: '許可証アップロード失敗',
        invalidFile: 'ファイルが無効です',
    },
    optionsLoadFailed: '選択肢の取得に失敗しました',
    validation: {
        companyNameRequired: '会社名を入力してください',
        mainIndustryRequired: '主な業種を選択してください',
        legalEntityRequired: '法人を入力してください',
        employeeCountRequired: '会社規模を選択してください',
        foreignEmployeeCountRequired: '外国人従業員数規模を選択してください',
        contactNameRequired: '氏名を入力してください',
        contactPhoneRequired: '電話番号／携帯番号を入力してください',
        legalPersonIdRequired: '法人番号を入力してください',
        corporateNumberLength: '法人番号は13桁の数字である必要があります',
        corporateNumberMust13Digits: '法人番号は13桁でなければなりません',
        insuranceNumberRequired: '雇用保険適用企業番号を入力してください',
        insuranceOfficeNumberRequired: '雇用保険適用事業所番号を入力してください',
        contactEmailRequired: 'メールアドレスを入力してください',
        employmentOfficeNumberLength: '雇用保険適用事業所番号は11桁の数字である必要があります',
        companyCategoryRequired: '会社区分を選択してください',
        companyTypeRequired: '会社の種類を選択してください',
        paidIntroductionLicenseNumberRequired: '収費職業紹介業務許可証号を入力してください',
        companyNameExists: 'この会社名は既に存在します',
        companyNameCheckFailed: '会社名の確認に失敗しました',
    },
};
